import React from "react";

// App
import { ApiPath, Field, Notice, Section, TagList } from "./apiField";

export default function FeaturesSection({
  features,
  services,
  roomFeatures = { features: [], path: "" },
  raw,
}) {
  return (
    <>
      <Section
        id="features"
        title="Meeting & event features"
        subtitle={features.heading || "Key features"}
        path={features.path}
        raw={raw}
      >
        {features.hotelDescription ? (
          <div className="rhp-prose">
            <p>{features.hotelDescription}</p>
            <ApiPath path={features.hotelDescriptionPath} />
          </div>
        ) : null}

        <TagList items={features.features} path={features.path} />

        {features.unlabelled.length ? (
          <Notice tone="warn">
            {features.unlabelled.length} entr
            {features.unlabelled.length === 1 ? "y" : "ies"} with no{" "}
            <code>feature</code> taxonomy
            {features.unlabelled.some((f) => f.text)
              ? `: ${features.unlabelled
                  .map((f) => f.text)
                  .filter(Boolean)
                  .join(", ")}`
              : ""}
            .
          </Notice>
        ) : null}

        <div className="rhp-grid rhp-grid--tight">
          {features.counts.map((count) => (
            <Field
              key={count.key}
              label={count.label}
              value={count.text}
              path={`${features.path} (key: ${count.key})`}
            />
          ))}
          <Field
            label="RFP email"
            value={features.rfpEmail}
            path={features.rfpEmailPath}
          />
          <Field
            label="Meetings page"
            value={features.link}
            path={features.linkPath}
          >
            {features.link ? (
              <a
                href={`https://www.radissonhotels.com${features.link}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {features.link}
              </a>
            ) : null}
          </Field>
        </div>
      </Section>

      <Section
        id="services"
        title="Hotel services"
        path={services.path}
      >
        <h3 className="rhp-subhead">Services</h3>
        <TagList items={services.services} path={services.path} />

        <h3 className="rhp-subhead">Service categories</h3>
        <TagList items={services.categories} path={services.categoriesPath} />

        <h3 className="rhp-subhead">Accessibility</h3>
        <TagList
          items={services.accessibility}
          path={services.accessibilityPath}
        />

        {roomFeatures.features.length ? (
          <>
            <h3 className="rhp-subhead">
              In-room features
              <span className="rhp-badge rhp-badge--imported">Imported</span>
            </h3>
            {/* Curated hotel-level list from the content spreadsheet. It overlaps
                the per-room amenities the API publishes but is not the same
                list, so it is shown separately rather than merged. */}
            <TagList items={roomFeatures.features} path={roomFeatures.path} />
          </>
        ) : null}
      </Section>
    </>
  );
}
